<template>
    <form class="oc-auth-reset" @submit.prevent="submit">
      <input v-model="code" type="text" class="oc-field__control" placeholder="Confirmation Code" required />
      <input v-model="password" type="password" class="oc-field__control" placeholder="New Password" required />
      <input v-model="password2" type="password" class="oc-field__control" placeholder="Confirm New Password" required />
      <input v-model="id" type="hidden" />
      <button type="submit" class="oc-btn oc-btn--primary oc-btn--block">Réinitialiser le mot de passe</button>
    </form>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  
  export default {
    setup() {
      const store = useStore();
      const code = ref('');
      const password = ref('');
      const password2 = ref('');
      const id = ref('');
  
      const submit = async () => {
        await store.dispatch('auth/resetPassword', {
          code: code.value,
          password: password.value,
          password2: password2.value,
          id: id.value
        });
      };
  
      return { code, password, password2, id, submit };
    }
  }
  </script>

<style>
/* ==================== NATIVE APP STYLES ====================
   Écran « nouveau mot de passe », aligné sur les trois autres écrans
   d'authentification. Les règles précédentes visaient `body.is-native form` :
   elles repeignaient TOUS les formulaires de l'app. Elles sont désormais
   rattachées à `.oc-auth-reset`, propre à ce composant.
   ============================================================ */

/* Le gabarit de la page affiche un titre « Reset Password » hérité du
   squelette : dans l'app, la barre d'application porte déjà le titre. */
body.is-native .page-main > div:has(> .oc-auth-reset) > h1 {
  display: none;
}

/* Carte blanche sur le fond chaud, bas dégagé pour le clavier. */
body.is-native .oc-auth-reset {
  display: flex;
  flex-direction: column;
  gap: var(--oc-sp-4);
  box-sizing: border-box;
  width: auto;
  margin: var(--oc-sp-5) var(--oc-sp-4) calc(var(--oc-sp-12) + var(--oc-safe-bottom));
  padding: var(--oc-sp-6) var(--oc-sp-5);
  background: var(--oc-surface);
  border-radius: var(--oc-r-lg);
  box-shadow: var(--oc-e1);
}

/* Le champ caché occupait une case de la colonne flex : une lacune de 16px
   sans rien dedans. */
body.is-native .oc-auth-reset input[type="hidden"] {
  display: none;
}

body.is-native .oc-auth-reset input[type="text"],
body.is-native .oc-auth-reset input[type="password"] {
  box-sizing: border-box;
  width: 100%;
  min-height: var(--oc-tap);
  height: 50px;
  margin: 0;
  padding: 0 var(--oc-sp-4);
  font-family: var(--oc-font-text);
  /* 16px au minimum : en dessous, iOS zoome à la mise au point du champ. */
  font-size: var(--oc-text-base);
  color: var(--oc-ink);
  background: var(--oc-surface);
  border: 1px solid var(--oc-line-2);
  border-radius: var(--oc-r-md);
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  transition: border-color var(--oc-fast) var(--oc-ease),
              box-shadow var(--oc-fast) var(--oc-ease);
}

body.is-native .oc-auth-reset input::placeholder {
  color: var(--oc-ink-3);
}

body.is-native .oc-auth-reset input:focus {
  border-color: var(--oc-brand);
  box-shadow: 0 0 0 3px var(--oc-brand-100);
}

body.is-native .oc-auth-reset button[type="submit"] {
  width: 100%;
  max-width: none;
  min-height: var(--oc-tap);
  height: 52px;
  margin: var(--oc-sp-1) 0 0;
  padding: 0 var(--oc-sp-5);
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-base);
  font-weight: 700;
  letter-spacing: 0.2px;
  text-transform: none;
  color: var(--oc-brand-ink);
  background: var(--oc-brand);
  border: 0;
  border-radius: var(--oc-r-full);
  box-shadow: var(--oc-e1);
  cursor: pointer;
}

body.is-native .oc-auth-reset button[type="submit"]:active {
  background: var(--oc-brand-600);
}
</style>
